// ─────────────────────────────────────────────────────────────────────────────
// Google reviews shown on the homepage (hard-coded — no widget, no limits).
// To update: edit/add entries below. Each has:
//   name, rating (1–5), date (free text like "1 month ago"), text
// ─────────────────────────────────────────────────────────────────────────────

export const overallRating = 5.0;   // header badge rating
export const totalReviews = 40;      // header badge count — set to your real Google total

const reviews = [
  {
    name: 'Michael',
    rating: 5,
    date: '24 days ago',
    text: 'Came in with a very dirty car that was full of pet hair, left with it looking like it was on the showroom floor. Great value, great service, great people.',
  },
  {
    name: 'Marilyn',
    rating: 5,
    date: '1 month ago',
    text: 'John was really nice, no nonsense, and made sure I was aware of my options as I accidentally chose the Ultimate. I don’t think my car was this clean the day I bought it from the dealership. 10/10 experience, worth every penny.',
  },
  {
    name: 'Lolly',
    rating: 5,
    date: '3 months ago',
    text: 'Super friendly service, reasonably priced, and very quick turnaround for a full interior detailing, but the best part is that there was no cloying new car/floral scent left behind to give you a headache! You can smell that the car’s clean but nothing else! Incredible!!',
  },
  {
    name: 'Freddy',
    rating: 5,
    date: '4 months ago',
    // Truncated in the widget — paste the full text from Google when you have it.
    text: 'I had a truck that had decals on it and needed an interior/exterior detail. John exceeded my expectations.',
  },
];

export default reviews;
